export enum depreciationMethodTypeEnum {
  StraightLineByDays = 0,
  IsNotAccrued = 1,
  StraightLine = 2,
}

